import axios, { AxiosRequestConfig } from 'axios';
import Analytics from '../analytics/Analytics';

export const sendNotification = async (
  title: string,
  message: string,
  createdBy: string,
  analytics: Analytics
) => {
  const topics = ['Updates'];
  const options: AxiosRequestConfig = {
    method: 'POST',
    data: {
      title,
      message,
      topics,
      createdBy,
      updatedBy: createdBy,
    },
    headers: { 'Content-Type': 'application/json' },
  };
  const sendTime = new Date().getTime();
  try {
    const res = await axios('/api/v1/notifications', options);
    const receiveTime = new Date().getTime();
    const responseTime = receiveTime - sendTime;
    analytics.track('apiCall', {
      opSuccess: true,
      appApiResponseTimeMs: responseTime,
      appApiResponseCode: res.status,
      appApiPath: '/api/v1/notifications',
      appApiQueryParameters: '',
      appApiHttpVerb: 'POST',
      appApiTraceId: 'Send Notification to Firebase',
      appApiDataCenter: 'SA Server',
      receivedTimestamp: receiveTime,
    });
    return res.data;
  } catch (error) {
    console.error(error);
    const receiveTime = new Date().getTime();
    const responseTime = receiveTime - sendTime;
    analytics.track('apiCall', {
      opSuccess: false,
      appApiResponseTimeMs: responseTime,
      appApiPath: '/api/v1/notifications',
      appApiHttpVerb: 'POST',
      appApiTraceId: 'Send Notification to Firebase',
      appApiDataCenter: 'SA Server',
      receivedTimestamp: receiveTime,
    });
    return Promise.reject(error);
  }
};

export const getAllNotifications = async (
  pageNumber: number,
  signal: AbortSignal,
  analytics: Analytics
) => {
  const options: AxiosRequestConfig = {
    method: 'GET',
    params: { order: 'desc', page: pageNumber, size: 10, sortBy: 'createdAt' },
    headers: { 'Content-Type': 'application/json' },
    signal,
  };
  const sendTime = new Date().getTime();
  try {
    const response = await axios('/api/v1/notifications', options);
    const receiveTime = new Date().getTime();
    const responseTime = receiveTime - sendTime;
    analytics.track('apiCall', {
      opSuccess: true,
      appApiResponseTimeMs: responseTime,
      appApiResponseCode: response.status,
      appApiPath: '/api/v1/notifications',
      appApiQueryParameters: '',
      appApiHttpVerb: 'GET',
      appApiTraceId: 'Get Notifications from server',
      appApiDataCenter: 'SA Server',
      receivedTimestamp: receiveTime,
    });
    return response.data;
  } catch (err) {
    console.warn(err);
    const receiveTime = new Date().getTime();
    const responseTime = receiveTime - sendTime;
    analytics.track('apiCall', {
      opSuccess: false,
      appApiResponseTimeMs: responseTime,
      appApiPath: '/api/v1/notifications',
      appApiHttpVerb: 'GET',
      appApiTraceId: 'Get Notifications from server',
      appApiDataCenter: 'SA Server',
      receivedTimestamp: receiveTime,
    });
    return err;
  }
};
